import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Card, Stack, Typography } from '@mui/material';
import useSWR from 'swr';

import Infoscreen from '@ui/Components/Infoscreen';
import NavigationLink from '@ui/Components/Link/NavigationLink';
import {
    CompanyDashboardSelect,
    DashboardCompanyData,
    DashboardSocialGroupData,
    SocialGroupDashboardSelect,
} from '@ui/Types/AuthServer';

interface InfoscreenListItemProps {
    infoscreen: CompanyDashboardSelect | SocialGroupDashboardSelect;
    selected?: boolean;
    // Renders a "View" button below the card instead of making the whole card
    // navigate, so the infoscreen preview's own buttons (e.g. calendar Show
    // week/day toggle) stay clickable without triggering navigation.
    to?: string;
}

export default function InfoscreenListItem({ infoscreen, selected, to }: Readonly<InfoscreenListItemProps>) {
    const { data: companyData } = useSWR<DashboardCompanyData>(
        infoscreen.type === 'Company' && infoscreen.open_dashboard && `users/dashboardcompany/${infoscreen.id}/`,
    );
    const { data: groupData } = useSWR<DashboardSocialGroupData>(
        infoscreen.type === 'Group' && infoscreen.open_dashboard && `users/dashboardsocialgroup/${infoscreen.id}/`,
    );

    return (
        <Box
            sx={{
                height: 396,
                width: 568,
            }}
        >
            <Card
                elevation={8}
                sx={{
                    borderColor: selected ? 'mlBlue.main' : '#adadb8',
                    borderRadius: 6,
                    borderStyle: 'solid',
                    borderWidth: 6,
                    height: 300,
                    position: 'relative',
                }}
            >
                <Stack
                    sx={{
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <Infoscreen
                        data={infoscreen.dashboard.socials}
                        onlineData={undefined}
                        small
                        users={infoscreen.type === 'Company' ? companyData?.users : groupData?.users}
                    />
                </Stack>
            </Card>
            <Stack
                direction="row"
                sx={{
                    alignItems: 'center',
                    height: 96,
                    justifyContent: 'space-between',
                    p: 1,
                }}
            >
                <Stack>
                    <Typography>
                        Name: <strong>{infoscreen.name}</strong>
                    </Typography>
                    <Typography>
                        Type: <strong>{infoscreen.type}</strong>
                    </Typography>
                    <Typography>
                        Open: <strong>{infoscreen.open_dashboard ? 'Yes' : 'No'}</strong>
                    </Typography>
                </Stack>
                {to ? (
                    <NavigationLink to={to}>
                        <Button endIcon={<ArrowForwardIcon />} size="small" variant="outlined">
                            View
                        </Button>
                    </NavigationLink>
                ) : null}
            </Stack>
        </Box>
    );
}
